module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "echarts",
    style: ({
      'width': _vm.chartWidth,
      'height': _vm.chartHeight
    })
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67e6d56c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/echarts.vue
// module id = 555
// module chunks = 23